<section id="technologies">
  <div class="container">
    <div class="technologies-wrap">
      <h2 class="title section-title">{{"technologies.title" | translate}}</h2>
      <p class="note">{{"technologies.note" | translate}}</p>
      <div class="technologies-box">
        <div class="entity" *ngFor="let item of technologies">
          <h3 class="title">{{ item.title }}</h3>
          <ul>
            <li *ngFor="let tech of item.list" class="tech">
              <i class="fa fa-check"></i>
              {{ tech }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
